declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export const initializeGTM = (): void => {
  const GTM_IDS: (string | undefined)[] = [process.env.REACT_APP_GTM_IDS01, process.env.REACT_APP_GTM_IDS02];
  GTM_IDS.forEach((gtmId: string | undefined) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const newScript = document.createElement('script') as HTMLScriptElement;
    newScript.async = true;
    newScript.src = `${process.env.REACT_APP_GTM_SCRIPT}${gtmId}`;
    document.body.appendChild(newScript);
  });
};
